/**
 * <ModalContent />
 *
 * @parent Modal
 * @stateless
 */
import React, { PropTypes } from 'react';
import QRCode from 'components/UI/QrCode';

class ModalContent extends React.Component {
  render() {
    const {
      value,
      showDownloadBtn
    } = this.props;

    return (
      <div className='custom-modal-content'>
        <QRCode value={value} showDownloadBtn={showDownloadBtn} />
      </div>
    )
  }
}

export default ModalContent;



// WEBPACK FOOTER //
// ./src/template/Modals/QrCode/ModalContent.js